import { Button } from "components/Button/Button";
import { motion } from "framer-motion";
import { ReactElement, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { MapEditorProvider, useMapEditorContext } from "./map-editor-provider";
import { useLangContext } from "context/Lang";
import {  MapEditorEnvironment } from "./map-editor-environment/editor-environment";
import { AppIcon } from "assets/app/app-icon";
import { AsyncProcess } from "services/AsyncProcess";
import { routes } from "routes";
import { ReplaceWords } from "utils/ReplaceWords";




type MapEditorProps = {
    // buildingId?: number;
    mapId?:number;
    mapEditorId?:number;
    canEdit?: boolean;
    onDataLoad?: (e?: any) => void;
    inDialog?:boolean;

}



export const MapEditor = ({ canEdit = true,inDialog=false,mapId, ...props }: MapEditorProps): ReactElement => {

    
    const [canEditServer,setCanEditServer] = useState<boolean>(false);
    const [searchParams] = useSearchParams();
    const mapEditorId = props?.mapEditorId || searchParams.get("mapEditorId");


    useEffect(()=>{
        canEdit&&AsyncProcess({
            type:"post",
            url:ReplaceWords(routes.api.mapEditorCheckEdit,{id:mapEditorId}),
            
            setError:()=>{

            },

            effectProcess:[(res)=>{
                if(res?.success!==false){
                    setCanEditServer(res?.data)
                }
            }]
        })
    },[]);  




    return <MapEditorProvider mapEditorId={props.mapEditorId}   onDataLoad={props?.onDataLoad}>
        <EditorContent  {...{ canEdit:canEditServer,inDialog }} />
    </MapEditorProvider>
}



const EditorContent = ({ canEdit,inDialog, ...props }: MapEditorProps) => {


    const navigate = useNavigate();
    const { gW, LanguagesDrop } = useLangContext();
    const {  } = useMapEditorContext();


    return (<>


        <div className=" w-full h-full  select-none overflow-hidden " >
            {canEdit && <div className=" relative backdrop-blur-lg     z-[100] top-0 left-0 p-2 gap-4  w-full  flex h-[64px]  border-b px-2  items-center     " >
                <motion.div initial={{ x: -100, opacity: 0 }} animate={{ x: 0, opacity: 1 }} transition={{ duration: 0.4, type: "spring" }} className=" h-full flex items-center  relative ">
                    <Button
                        variant="ghost"
                        onClick={() => navigate(-1)} className="   ">
                        <AppIcon />
                    </Button>
                </motion.div>
            </div>}
            <MapEditorEnvironment
                canEdit={canEdit}
                inDialog={inDialog}

            />

        </div>

    </>);

}